<script>
  import Breadcrumbs from './Breadcrumbs.svelte';
  import { notes } from './data/notes.js';

  let { noteId = '', selectNote = () => {}, navigate = () => {} } = $props();

  let noteIndex = $derived(notes.findIndex(n => n.id === noteId));
  let note = $derived(notes[noteIndex] || notes[0]);
  let prevNote = $derived(noteIndex > 0 ? notes[noteIndex - 1] : null);
  let nextNote = $derived(noteIndex < notes.length - 1 ? notes[noteIndex + 1] : null);

  $effect(() => {
    if (noteId) {
      window.scrollTo(0, 0);
    }
  });
</script>

<div class="note-detail-container">
  <div class="panel article-panel">
    <div class="header-nav">
      <!-- CS DIRECTORY FILE PATH NAVIGATION -->
      <Breadcrumbs 
        currentView="note-detail" 
        {noteId} 
        noteTitle={note.title} 
        onnavigate={(view, slug) => navigate(view, slug)} 
      />

      <div class="meta-row">
        <span class="date">{note.date}</span>
        <span class="dot">•</span>
        <span class="read-time">{note.readTime}</span>
      </div>
    </div>

    <h1 class="title">{note.title}</h1>

    <hr class="divider" />

    <div class="article-body">
      {@html note.content}
    </div>

    <footer class="article-footer">
      <hr class="divider" />
      <div class="nav-footer">
        {#if prevNote}
          <button class="nav-note-btn prev" onclick={() => selectNote(prevNote.id)}>
            <span class="nav-label">← Newer Post</span>
            <span class="nav-title">{prevNote.title}</span>
          </button>
        {:else}
          <div></div>
        {/if}

        {#if nextNote}
          <button class="nav-note-btn next" onclick={() => selectNote(nextNote.id)}>
            <span class="nav-label">Older Post →</span>
            <span class="nav-title">{nextNote.title}</span>
          </button>
        {/if}
      </div>
    </footer>
  </div>
</div>

<style>
  .note-detail-container {
    width: 100%;
    max-width: 900px;
    margin: 0 auto;
    animation: fade 0.3s ease-in-out;
  }

  @keyframes fade {
    from { opacity: 0; transform: translateY(6px); }
    to { opacity: 1; transform: translateY(0); }
  }

  .panel {
    background: #000000;
    border: 1px solid #ffffff;
    border-radius: clamp(16px, 2vw, 32px);
    padding: clamp(1.5rem, 4vw, 3.5rem);
  }

  .header-nav {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 1rem;
    margin-bottom: 1.5rem;
    flex-wrap: wrap;
  }

  .meta-row {
    font-size: 0.85rem;
    color: #888;
    display: flex;
    align-items: center;
    gap: 0.4rem;
  }

  .title {
    font-size: clamp(2rem, 4vw, 2.8rem);
    font-weight: 700;
    color: #ffffff;
    margin: 0 0 1rem 0;
    line-height: 1.25;
  }



  .divider {
    border: 0;
    height: 1px;
    background: #222;
    margin: 1.5rem 0 2rem 0;
  }

  .article-body {
    font-size: clamp(1rem, 1.4vw, 1.15rem);
    line-height: 1.8;
    color: #d8d8d8;
  }

  .article-body :global(p) {
    margin-bottom: 1.4rem;
  }

  .article-body :global(h2), .article-body :global(h3) {
    color: #ffffff;
    margin-top: 2rem;
    margin-bottom: 0.8rem;
    font-weight: 600;
  }

  .article-body :global(ul), .article-body :global(ol) {
    padding-left: 1.5rem;
    margin-bottom: 1.4rem;
  }

  .article-body :global(li) {
    margin-bottom: 0.4rem;
  }

  .article-body :global(code) {
    background: #18181b;
    color: #e4e4e7;
    padding: 0.2rem 0.4rem;
    border-radius: 4px;
    font-family: ui-monospace, SFMono-Regular, Consolas, monospace;
    font-size: 0.9em;
    border: 1px solid #27272a;
  }

  .article-body :global(pre) {
    background: #09090b;
    border: 1px solid #27272a;
    padding: 1.25rem;
    border-radius: 8px;
    overflow-x: auto;
    margin: 1.5rem 0;
  }

  .article-body :global(pre code) {
    background: transparent;
    padding: 0;
    color: #f4f4f5;
    border: none;
  }

  .article-body :global(blockquote) {
    border-left: 3px solid #ffffff;
    margin: 1.5rem 0;
    padding: 0.6rem 1rem;
    color: #a1a1aa;
    font-style: italic;
    background: #09090b;
    border-radius: 0 8px 8px 0;
  }

  .nav-footer {
    display: flex;
    justify-content: space-between;
    gap: 1rem;
    flex-wrap: wrap;
  }

  .nav-note-btn {
    background: #050505;
    border: 1px solid #27272a;
    border-radius: 12px;
    padding: 1rem;
    color: #e0e0e0;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    text-align: left;
    transition: all 0.2s ease;
    max-width: 45%;
    flex: 1;
  }

  .nav-note-btn.next {
    text-align: right;
    align-items: flex-end;
  }

  .nav-note-btn:hover {
    border-color: #ffffff;
    background: #111111;
  }

  .nav-label {
    font-size: 0.75rem;
    color: #888;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-bottom: 0.3rem;
  }

  .nav-title {
    font-size: 0.95rem;
    font-weight: 600;
    color: #fff;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
  }
</style>
